import React, { PureComponent } from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { Grid, Theme, Typography } from "@material-ui/core";
import { StepStatus, StepProps } from "./types/Stepper";

const styles = (theme: Theme) =>
  createStyles({
    stepContainer: {
      width: "100%",
      backgroundColor: "#fff",
      borderRadius: "4px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      padding: "18px 24px",
      // marginTop: "10px"
    },
    unPad: {
      margin: "0 -10px",
    },
    title: {
      fontSize: "16px",
      color: "#333",
      fontWeight: 600,
      marginBottom: 4,
    },
    subHeading: {
      fontSize: "14px",
      color: "#666",
      fontWeight: "normal",
    },
    statusIconContainer: {
      marginRight: "14px",
    },
    disableSteps : {
      opacity : 0.4,
    },
  });

// Add something to StepProps instead if MyPATExpansionStep will accept that prop too
interface Props extends WithStyles<typeof styles>, StepProps {
  plain?: boolean;
  isDisabled?: boolean
}

interface SubComponentProps {
  children: React.ReactNode;
  isDisabled?: boolean
  
}

// @ts-ignore
const StepContext = React.createContext();

class MyPATStep extends PureComponent<Props> {
  renderStatusIcon = () => {
    const { status } = this.props;
    let path = "";
    switch (status) {
      case StepStatus.PENDING: {
        path = "/assets/svg/contentRequest/step-pending.svg";
        break;
      }
      case StepStatus.INPROGRESS: {
        path = "/assets/svg/contentRequest/step-inprogress.svg";
        break;
      }
      case StepStatus.DONE: {
        path = "/assets/svg/contentRequest/step-done.svg";
        break;
      }
      default:
        break;
    }
    return <img src={path} alt={status} />;
  };
  render() {
    const { classes, plain } = this.props;

    return (
      <Grid
        container
        className={!plain ? classes.stepContainer : "" }
        alignItems="flex-start"
      >
        <div className={classes.statusIconContainer}>
          {this.renderStatusIcon()}
        </div>
        <Grid item xs>
          <StepContext.Provider value={classes}>
            {this.props.children}
          </StepContext.Provider>
        </Grid>
      </Grid>
    );
  }
}

function MyPATStepTitle({ children, isDisabled }: SubComponentProps) {
  // console.log('opacity ', isDisabled);
  return (
    <StepContext.Consumer>
      {(classes: any) => (
        <Typography className={isDisabled ? [classes.disableSteps, classes.title]: classes.title } variant="h4" >
          {children}
        </Typography>
      )}
    </StepContext.Consumer>
  );
}

function MyPATStepSubHeading({ children }: SubComponentProps) {
  return (
    <StepContext.Consumer>
      {(classes: any) => (
        <Typography className={classes.subHeading} variant="subheading">
          {children}
        </Typography>
      )}
    </StepContext.Consumer>
  );
}

export { MyPATStepTitle, MyPATStepSubHeading };

// @ts-ignore
export default withStyles(styles)(MyPATStep);
